import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Modal,
  message,
  Checkbox,
  Space,
  Table,
  Popconfirm,
} from 'antd'
import { PlusOutlined, MinusOutlined, InboxOutlined } from '@ant-design/icons'
import styles from './Step3.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import Dragger from 'antd/es/upload/Dragger'
import _default from 'antd/es/affix/style'

const { TextArea } = Input
const Step3 = (props) => {
  useEffect(() => {}, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      // width: '96px',
      render: (_, record) => <Space size="middle">{_}</Space>,
    },

    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
          style={{
            color:
              _.trim().length > 0 && _.trim() !== 'undefined' ? '#000' : 'red',
          }}
        >
          {_.trim().length > 0 && _.trim() !== 'undefined' ? _ : '请输入姓名'}
        </Space>
      ),
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
          style={{ color: /^1[3-9]\d{9}$/.test(_.trim()) ? '#000' : 'red' }}
        >
          {_.trim() !== 'undefined' ? _ : '请输入手机号'}
        </Space>
      ),
    },
    {
      title: '积分限额',
      dataIndex: 'points',
      key: 'points',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
          style={{
            color:
              /^(0|[1-9]\d*)$/.test(_.trim()) &&
              _.trim() >= 0 &&
              _.trim() !== 'undefined'
                ? '#000'
                : 'red',
          }}
        >
          {_.trim().length > 0 && _.trim() !== 'undefined'
            ? _
            : '请输入积分限额'}
        </Space>
      ),
    },
    {
      title: '在校身份',
      dataIndex: 'job',
      key: 'job',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
          style={{
            color:
              _.trim().length > 0 && _.trim() !== 'undefined' ? '#000' : 'red',
          }}
        >
          {_.trim().length > 0 && _.trim() !== 'undefined'
            ? record.job
            : '请输入在校身份'}
        </Space>
      ),
    },
    {
      title: '授课年级',
      dataIndex: 'grade',
      key: 'grade',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
          style={{
            color:
              _.trim().length > 0 && _.trim() !== 'undefined' ? '#000' : 'red',
          }}
        >
          {_.trim().length > 0 && _.trim() !== 'undefined'
            ? _
            : '请输入授课年级'}
        </Space>
      ),
    },
    {
      title: '操作',
      dataIndex: 'opration',
      key: 'opration',
      align: 'center',
      render: (_, record) => (
        <Space
          size="middle"
        >
          <Popconfirm
            title={
              '提示'
            }
            description={
              '确认删除该老师信息吗？此操作不可撤销。'
            }
            okText="确认"
            okType="danger"
            onConfirm={() => {
              props.deleteAccount(record)
            }}
          >
            <Button type="link">删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ]

  return (
    <div>
      <div className={styles.previewContainer}>数据预览</div>

      <Table
        columns={columns}
        dataSource={props.accountList}
        // pagination={{
        //     current: currentPage, // 当前页码
        //     pageSize: pageSize, // 每页条数
        //     total: total, // 数据总条数
        //     onChange: handlePageChange, // 分页改变时的回调函数
        //     showSizeChanger: true, // 是否显示每页条数改变的选项
        //     // showQuickJumper: true, // 是否可以快速跳转到指定页
        //     // showTotal: (total) => `共 ${total} 条数据`, // 显示数据总量的函数
        //     hideOnSinglePage:false
        // }}
        pagination={false}
        bordered
        // scroll={{
        //     x: 'max-content',
        //     y: 55 * 5,
        // }}
        tableLayout="auto"
        style={{ height: 'calc(100vh - 400px)' ,overflowY:'auto'}}
      />
      <div className={styles.dataCount}>共{props.accountList.length}条数据</div>

      <div className={styles.bottomButton}>
        <Button
          color="default"
          variant="outlined"
          style={{ marginLeft: '820px' }}
          onClick={() => {
            props.prevStep()
          }}
        >
          上一步
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: '20px' }}
          onClick={() => {
            props.importAccount()
          }}
        >
          确认导入
        </Button>
      </div>
    </div>
  )
}

export default Step3

